import AppBar from "@mui/material/AppBar";
import { AddShoppingCart as AddShoppingCartIcon } from "@mui/icons-material";
import { ShoppingCart as ShoppingCartIcon } from "@mui/icons-material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { ArrowRightAltRounded as ArrowRightAltRoundedIcon } from "@mui/icons-material";
import templeLogo from "../../assets/temple-logo-icon.png";
import searchbirla from "../../assets/profilebackground.webp";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import RightDrawer from "../drawer/RightDrawer";
import "./Header.scss";
import { useDispatch, useSelector } from "react-redux";
import AvatarGenerator from "../profilePic/GenerateAvatar";
import { Box, Grid, Typography, Button, Select, MenuItem } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { TextContext } from "../../text/TextProvider";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { ModeEditRounded as ModeEditRoundedIcon } from "@mui/icons-material";
import { getPriceConversionRate } from "../../store/actions/priceConversionAction";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import { LOCALSTORAGE_KEY, templedekhoBlogUrl } from "../../utils/Constants";
import CartDropdown from "../CartDropdown/CartDropdown";
import { setNavigatedFromToLogin } from "../../store/slices/analyticsSlice";
import ImageView from "../ImageView/ImageView";
function Header(props: any) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { pujaCategoryList } = useSelector((state: any) => state.puja);
  const [searchBoxPopUp, setSearchBoxPopUp] = useState(false);
  const [notificationBoxPopup, setNotificationBoxPopUp] = useState(false);
  const [openRightSidePanel, setOpenRightSidePanel] = useState(false);
  const [openLanguageSelection, setOpenLanguageSelection] = useState(false);
  const [languageSelect, setLanguageSelect] = useState<any>("");
  const [userAddressInfoAggregated, setUserAddressInfoAggregated]: any =
    useState(null);
  var { userInfo, selectedAddressId, currentGPSAddress } = useSelector(
    (state: any) => state.user
  );
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const { clientIp } = priceConversionState.priceConversionRate || {};
  const personalInfo = userInfo?.personalInfo;
  const { cartInfo } = useSelector((state: any) => state.cart);
  const textContext: any = useContext(TextContext);
  const [isCartDropdownOpen, setIsCartDropdownOpen] =
    useState<null | HTMLElement>(null);
  const floatCartRefEl = useRef<any>();

  const handleCartMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setIsCartDropdownOpen(event.currentTarget);
  };
  const handleCartMenuClose = () => {
    setIsCartDropdownOpen(null);
  };
  // End
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const ppUrl = personalInfo?.profilePictureUrl || "";
  const userFName = personalInfo?.firstName || " ";
  const userLName = personalInfo?.lastName || " ";
  const userAddressList = personalInfo?.address || [];

  const generateUserAddressData = () => {
    if (currentGPSAddress && !selectedAddressId) {
      return currentGPSAddress.address;
    } else if (userAddressList && userAddressList.length > 0) {
      if (selectedAddressId && selectedAddressId?.trim().length > 0) {
        const selectedUserAddress = userAddressList?.filter(
          (item: any) => item.id === selectedAddressId
        );
        return selectedUserAddress[0];
      } else {
        return userAddressList[0];
      }
    } else {
      return null;
    }
  };

  useEffect(() => {
    const aggregatedAdresss = generateUserAddressData();
    setUserAddressInfoAggregated(aggregatedAdresss);
  }, [currentGPSAddress, selectedAddressId, userInfo]);

  const addressCityName =
    userAddressInfoAggregated && userAddressInfoAggregated.city
      ? userAddressInfoAggregated.city
      : "Temple Dekho";

  const addressData =
    userAddressInfoAggregated && userAddressInfoAggregated.formatted_address
      ? userAddressInfoAggregated.formatted_address
      : "Connecting Souls to Spirituality";

  const shotrenedAddress =
    addressData.length > 32
      ? addressData.substring(0, 32) + "..."
      : addressData;

  useEffect(() => {
    if (!clientIp && currentGPSAddress?.address) {
      const address = currentGPSAddress?.address;
      const ratePayload: any = { ...address };
      ratePayload["country_code"] = address?.countryCode;
      delete ratePayload["countryCode"];
      dispatch(getPriceConversionRate(ratePayload));
    }
  }, [currentGPSAddress]);

  useEffect(() => {
    const savedLanguage = props?.ln;
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setLanguageSelect(savedLanguage);
    }
  }, [props?.ln]);

  useEffect(() => {
    i18n.changeLanguage(languageSelect);
  }, [languageSelect]);

  const handleLangugeSelect = (e: any) => {
    e.preventDefault();
    if (languageSelect !== e.target.value) {
      setLanguageSelect(e.target.value);
      localStorage.setItem(LOCALSTORAGE_KEY.LANG_CODE, e.target.value);
      queryParams.set("ln", e.target.value);
      navigate(`${location.pathname}?${queryParams.toString()}`, {
        replace: true,
      });
    }
  };

  const HrefUI = ({ onClick, children }: any) => {
    return (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        {children}
      </a>
    );
  };

  return (
    <Box>
      {windowDimensions.width < 900 ? (
        <Box className="headerSm">
          <Box className="headerSmLeft">
            <Box className="addressText">
              <Typography>
                {addressCityName}{" "}
                {userAddressInfoAggregated ? (
                  <ModeEditRoundedIcon
                    onClick={() => navigate("/profile/address")}
                  />
                ) : null}
              </Typography>
              <Typography>{shotrenedAddress}</Typography>
            </Box>
          </Box>
          <Box className="headerSmRight">
            {/* <Box className="headLang">
              <Button
                className="btn btn-default"
                onClick={() => setOpenLanguageSelection(true)}
              >
                <img src={langImg}></img>
              </Button>
            </Box> */}
            {/* <Box
              className={isActive("/apps") ? "displayNone" : "appDownloadInfo"}
            >
              <Link to={"/apps"} className="downloadBtnText" target="_blank">
                <Tooltip title="Download App">
                  <GetAppIcon sx={{ color: "#d56939", marginRight: "10px" }} />
                </Tooltip>
              </Link>
            </Box> */}

            <Box className="languageSelect">
              <FormControl size="small">
                <Select
                  value={languageSelect}
                  onChange={handleLangugeSelect}
                  displayEmpty
                  IconComponent={() => null}
                  className="langDpdn"
                  inputProps={{
                    "aria-label": "Select Language",
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        marginTop: "5px",
                        boxShadow: "none",
                        border: "1px solid #e5e7eb",
                      },
                    },
                    MenuListProps: {
                      sx: { padding: 0 },
                    },
                  }}
                  renderValue={(selected) => {
                    const shortLabels: any = { en: "En", hi: "हि", bn: "বা" };
                    return shortLabels[selected] || "En";
                  }}
                  notched={false}
                >
                  <MenuItem value="en">English</MenuItem>
                  <MenuItem value="hi">हिन्दी</MenuItem>
                  <MenuItem value="bn">বাংলা</MenuItem>
                </Select>
              </FormControl>
            </Box>

            <Box className="headProfile">
              {userInfo ? (
                <Box
                  className="profileBlock"
                  onClick={() => setOpenRightSidePanel(true)}
                >
                  <HrefUI
                    onClick={() => {
                      setOpenRightSidePanel(true);
                    }}
                  >
                    {ppUrl ? (
                      <ImageView
                        src={ppUrl}
                        width={34}
                        height={34}
                        sizes="(max-width: 768px) 34px, 34px"
                        style={{ width: "34px", height: "34px" }}
                        alt="User Profile"
                      />
                    ) : (
                      <AvatarGenerator
                        firstName={userFName}
                        lastName={userLName}
                      />
                    )}
                  </HrefUI>
                </Box>
              ) : (
                <Box
                  className="profileBlock"
                  onClick={() => navigate("/login")}
                >
                  {/* <Link to={"/profile/personalInfo"}> */}
                  <HrefUI
                    onClick={() => {
                      const navigatedFrom = location.pathname;
                      if (navigatedFrom) {
                        dispatch(setNavigatedFromToLogin(navigatedFrom));
                      }
                      navigate("/login");
                    }}
                  >
                    <Button
                      className="logoutProfile"
                      variant="text"
                      sx={{ padding: "0 0 0 8px" }}
                      startIcon={
                        <AccountCircleRoundedIcon
                          sx={{ fontSize: "25px !important" }}
                        />
                      }
                    >
                      {t(LOCALIZATION.Login)}
                    </Button>
                  </HrefUI>
                </Box>
              )}
            </Box>
          </Box>
          <RightDrawer
            openRightSidePanel={openRightSidePanel}
            setOpenRightSidePanel={setOpenRightSidePanel}
          />
        </Box>
      ) : (
        <Box className="headerMainNav">
          <AppBar component="nav">
            <nav className="headerContainer">
              <Grid
                container
                alignItems="center"
                spacing={2}
                className="row d-flex mainGrid"
              >
                <Grid item md={3} lg={3} xl={3} className="hdLeftGrid">
                  <Box className="headerLeft">
                    <Box className="logo">
                      <NavLink to="/" className={isActive("/") ? "active" : ""}>
                        <img src={templeLogo} alt="temp logo" width={24} />
                      </NavLink>
                    </Box>
                    {/* <Box
                      className="searchAutoPopulate"
                      onClick={() => setSearchBoxPopUp(!searchBoxPopUp)}
                    >
                      <Box className="searchBlock">
                        <form className="d-flex" role="search">
                          <input
                            className="form-control searchInput"
                            type="search"
                            placeholder="Search your thoughts..."
                            aria-label="Search"
                          ></input>
                          <button
                            className="btn btnSecondary btnSearch"
                            type="submit"
                          >
                            <i className="bi bi-search"></i>
                          </button>
                        </form>
                      </Box>
                    </Box> */}
                    <Box className="logoText">
                      <NavLink to="/" className={isActive("/") ? "active" : ""}>
                        <Typography className="logoTextTitle">
                          Temple Dekho
                        </Typography>
                        <Typography className="logoTextSubTitle">
                          {t("tagline")}
                        </Typography>
                      </NavLink>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={6} lg={6} xl={6} className="hdCenterGrid">
                  <Box className="headerCenter">
                    <Box className="navLink">
                      <ul className="links">
                        <li>
                          <NavLink
                            to="/"
                            className={
                              isActive("/") || isActive("/") ? "active" : ""
                            }
                          >
                            {t(LOCALIZATION.Home)}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/temples"
                            className={isActive("/temples") ? "active" : ""}
                          >
                            {t(LOCALIZATION.Temples)}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/pujas"
                            className={isActive("/pujas") ? "active" : ""}
                          >
                            {t("Pujas")}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/chadhavaTemples"
                            className={
                              isActive("/chadhavaTemples") ? "active" : ""
                            }
                          >
                            {t(LOCALIZATION.Chadhava)}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={`/search/category/${
                              pujaCategoryList?.length > 0
                                ? pujaCategoryList[0]?.categoryId
                                : "cat_relief"
                            }`}
                            className={
                              isActive("search/category") ? "active" : ""
                            }
                          >
                            {t(LOCALIZATION.Remedy)}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/prasadTemples"
                            className={
                              isActive("/prasadTemples") ? "active" : ""
                            }
                          >
                            {t(LOCALIZATION.Prasad)}
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to={templedekhoBlogUrl}>
                            {t(LOCALIZATION.Blog)}
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to="/livedarshan"
                            className={isActive("/livedarshan") ? "active" : ""}
                          >
                            {t(LOCALIZATION.Darshan)}
                          </NavLink>
                        </li>
                      </ul>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={3} lg={3} xl={3} className="hdRightGrid">
                  <Box className="headerRight">
                    {/* <Box
                      className={
                        isActive("/apps") ? "displayNone" : "appDownloadInfo"
                      }
                    >
                      <Button variant="contained" className="downloadBtnInfo">
                        <Link
                          to={"/apps"}
                          className="downloadBtnText"
                          target="_blank"
                        >
                          {t(LOCALIZATION.Download_App)}
                        </Link>
                      </Button>
                    </Box> */}
                    <Box className="languageSelect">
                      <FormControl size="small">
                        <Select
                          value={languageSelect}
                          onChange={handleLangugeSelect}
                          displayEmpty
                          IconComponent={ExpandMoreIcon}
                          className="langDpdn"
                          inputProps={{
                            "aria-label": "Select Language",
                          }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                marginTop: "5px",
                                boxShadow: "none",
                                border: "1px solid #e5e7eb",
                              },
                            },
                            MenuListProps: {
                              sx: { padding: 0 },
                            },
                          }}
                          notched={false}
                        >
                          <MenuItem value="en">English</MenuItem>
                          <MenuItem value="hi">हिन्दी</MenuItem>
                          <MenuItem value="bn">বাংলা</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>

                    <Box
                      className="cartBlock"
                      ref={floatCartRefEl}
                      style={{
                        marginRight: "15px",
                      }}
                    >
                      <Box
                        onClick={(e: any) => {
                          if (cartInfo?.length === 0) {
                            navigate("/checkoutV2/reviewCart");
                            return;
                          }
                          handleCartMenuClick(e);
                        }}
                        sx={{ cursor: "pointer" }}
                      >
                        <span className="cartBadge">{cartInfo.length}</span>
                        <ShoppingCartIcon />
                      </Box>
                    </Box>

                    {userInfo ? (
                      <Box
                        className="profileBlock"
                        onClick={() => setOpenRightSidePanel(true)}
                      >
                        {/* <Link to={"/profile/personalInfo"}> */}
                        {/* <Link to="#"> */}
                        <HrefUI
                          onClick={() => {
                            setOpenRightSidePanel(true);
                          }}
                        >
                          {ppUrl ? (
                            <ImageView
                              src={ppUrl}
                              width={34}
                              height={34}
                              sizes="(max-width: 768px) 34px, 34px"
                              style={{ width: "34px", height: "34px" }}
                              alt="User Profile"
                            />
                          ) : (
                            <AvatarGenerator
                              firstName={userFName}
                              lastName={userLName}
                            />
                          )}
                          {/* </Link> */}
                        </HrefUI>
                      </Box>
                    ) : (
                      <Box className="profileBlock">
                        {/* <Link to={"/profile/personalInfo"}> */}

                        {/* <img
                            style={{ width: "34px", height: "34px" }}
                            src={
                              "https://png.pngtree.com/png-clipart/20191122/original/pngtree-user-icon-isolated-on-abstract-background-png-image_5192004.jpg"
                            }
                            alt=""
                          /> */}

                        <HrefUI
                          onClick={() => {
                            const navigatedFrom = location.pathname;
                            if (navigatedFrom) {
                              dispatch(setNavigatedFromToLogin(navigatedFrom));
                            }
                            navigate("/login");
                          }}
                        >
                          <Button
                            className="logoutProfile"
                            variant="text"
                            startIcon={<AccountCircleRoundedIcon />}
                          >
                            {t(LOCALIZATION.Login)}
                          </Button>
                        </HrefUI>
                      </Box>
                    )}
                  </Box>
                </Grid>
              </Grid>

              {searchBoxPopUp ? (
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setSearchBoxPopUp(false);
                  }}
                >
                  <Box className="searchBoxPopUp">
                    <Box className="searchMenu">
                      <Box className="recent">
                        <h6>Rrecommendation</h6>
                      </Box>
                      <Box className="edit">
                        <a href="#">Edit</a>
                      </Box>
                    </Box>
                    <Box className="searchItem">
                      <Box className="recentProfile">
                        <Box className="rpImage">
                          <img src={searchbirla} alt="search birla" />
                        </Box>
                        <Box className="rpName">
                          <h6>Birla Temple</h6>
                        </Box>
                      </Box>
                      <Box className="closeIcon">
                        <a href="#">
                          <i className="bi bi-x"></i>
                        </a>
                      </Box>
                    </Box>
                    {/* {templesSuggestions &&
                  templesSuggestions.organisation &&
                  templesSuggestions.organisation.map((item: any, id: any) => {
                    if (id < 5) {
                      return (
                        <div className="searchItem">
                          <div className="recentProfile">
                            <div className="rpImage">
                              <img
                                src={
                                  item.personalInfo &&
                                  item.personalInfo.media &&
                                  item.personalInfo.media.pictures &&
                                  item.personalInfo.media.pictures[0] &&
                                  item.personalInfo.media.pictures[0].pictureUrl
                                    ? item.personalInfo.media.pictures[0]
                                        .pictureUrl
                                    : ""
                                }
                                alt=""
                              />
                            </div>
                            <div className="rpName">
                              <h6>
                                {item.personalInfo && item.personalInfo.name
                                  ? item.personalInfo.name
                                  : ""}
                              </h6>
                            </div>
                          </div>
                          <div className="closeIcon">
                            <a href="#">
                              <i className="bi bi-x"></i>
                            </a>
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })} */}
                  </Box>
                </OutsideClickHandler>
              ) : null}

              {notificationBoxPopup ? (
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setNotificationBoxPopUp(false);
                  }}
                >
                  <Box className="notificationPannel">
                    <Box className="notificationDetails">
                      <Box className="unreadMark"></Box>
                      <Box className="messageText">
                        <h6>
                          Your order has been picked up <p>Now</p>
                        </h6>
                      </Box>
                    </Box>
                    <Box className="solidLine"></Box>
                    <Box className="notificationDetails">
                      <Box className="unreadMark"></Box>
                      <Box className="messageText">
                        <h6>
                          Your order has been picked up <p>1 h ago</p>
                        </h6>
                      </Box>
                    </Box>
                    <Box className="solidLine"></Box>
                    <Box className="notificationDetails">
                      <Box className="unreadMark"></Box>
                      <Box className="messageText">
                        <h6>
                          Lorem ipsum dolor sit amet, <p>3 h ago</p>
                        </h6>
                      </Box>
                    </Box>
                    <Box className="solidLine"></Box>
                    <Box className="notificationDetails">
                      <Box className="unreadMark"></Box>
                      <Box className="messageText">
                        <h6>
                          Lorem ipsum dolor sit amet, <p>5 h ago</p>
                        </h6>
                      </Box>
                    </Box>
                    <Box className="solidLine"></Box>
                    <Box className="moreBtn">
                      <button>
                        Load more
                        <ArrowRightAltRoundedIcon />
                      </button>
                    </Box>
                  </Box>
                </OutsideClickHandler>
              ) : null}
              <Box className="toggleBtn">
                <MenuIcon />
              </Box>
            </nav>
          </AppBar>

          <RightDrawer
            openRightSidePanel={openRightSidePanel}
            setOpenRightSidePanel={setOpenRightSidePanel}
          />
        </Box>
      )}
      <Dialog
        className="startPostInput langWindow"
        onClose={() => setOpenLanguageSelection(false)}
        open={openLanguageSelection}
      >
        <Box className="langContainer">
          <FormControl className="langFormControl">
            <RadioGroup
              className="langRadioGroup"
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="english"
              name="radio-buttons-group"
            >
              <FormLabel id="demo-radio-buttons-group-label">
                Choose Language
              </FormLabel>
              <Box className="langBtn">
                <FormControlLabel
                  value="english"
                  control={<Radio />}
                  label="English"
                  onClick={() => textContext.setTextData("ENGLISH")}
                />
                {/* <RoundedButton
                  title="English"
                  onClick={() => textContext.setTextData("ENGLISH")}
                ></RoundedButton> */}
                <span className="langLetter">A</span>
              </Box>
              <Box className="langBtn">
                <FormControlLabel
                  value="हिन्दी"
                  control={<Radio />}
                  label="हिन्दी"
                  onClick={() => textContext.setTextData("HINDI")}
                />
                {/* <RoundedButton
                  title="हिन्दी"
                  onClick={() => textContext.setTextData("HINDI")}
                ></RoundedButton> */}
                <span className="langLetter">अ</span>
              </Box>
              <Box className="langBtn">
                <FormControlLabel
                  value="বাংলা"
                  control={<Radio />}
                  label="বাংলা"
                  onClick={() => textContext.setTextData("BENGALI")}
                />
                {/* <RoundedButton
                  title="বাংলা"
                  onClick={() => textContext.setTextData("BENGALI")}
                ></RoundedButton> */}
                <span className="langLetter">ক</span>
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
      </Dialog>
      {cartInfo?.length > 0 && (
        <CartDropdown
          isOpen={isCartDropdownOpen}
          anchorEl={isCartDropdownOpen ? floatCartRefEl.current : null}
          handleClose={handleCartMenuClose}
          cartItems={cartInfo}
        />
      )}
    </Box>
  );
}

export default Header;
